<template>
  <div>
    <div class="flex flex-wrap w-full mb-10">
      <div class="w-3/4">
        <div class="not-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200">
          {{ $t('message.FileUploadComponent.formComponent.preview') }}
        </div>
      </div>
      <div v-if="
        countDocumentsToUpload === this.documentsToUpload.length &&
        loading === false
      " class="float-right w-1/4">
      </div>
    </div>
    <div v-show="!imgSrc" class="mt-10">
      <vue-loading style="margin:auto; margin-top: 0; left:0; right:0; top:0; bottom:0; z-index: 9999;" v-if="loading"
        background-color="rgba(255,255,255,0.75)" :active="loading" color="#004250" :width="100" :height="100" />
      <template v-if="loading === false">
        <template>
          <transition v-for="(item, key) in documentsToUpload" :key="item.order" name="fade">
            <div class="containersWrapperDocuments" :ref="item.order" :key="item.order">
              <div class="containerPicker-Title">
                <span class="picker-title">{{
                  metadata.nombre ? metadata.nombre : 'Imagen ' + (key + 1)
                }}</span>
              </div>
              <div class="text-zt-primary-200" v-if="isAKindOfDni">
                <span>{{ dniLabels[key] }}</span>
              </div>
              <div class="pdfShowContainer mt-4" v-if="item.value !== '' && item.hasOwnProperty('file')">
                <div class="imageContainerDashboard" v-if="validImage(item)">
                  <img class="imageContentDashboard" :src="item.file.UrlOnLoad" alt="" />
                </div>
                <div v-else-if="item.mimeType === 'application/pdf'" class="pdf-thumb">
                  <zt-pdf-viewer
                    :ref="`ztPDFViewer_${key}`"
                    :src="item.file.UrlOnLoad"
                    :page="1"
                    :show-control="false"
                    @page-count="fitPdfThumb(key)"
                  ></zt-pdf-viewer>
                </div>
              </div>
              <div v-else class="pickers-container">
                <div class="filepicker-section">
                  <div class="left-picker" @click="showFileChooseWindow(key)">
                    <div class="imageUpload"></div>
                    <div class="uploadTitles">{{ imageText }}</div>
                  </div>
                  <div class="lineSeparator"></div>
                  <div class="right-picker" @click="choosePdfFile(key)">
                    <div class="pdfUpload"></div>
                    <div class="uploadTitles">{{ pdfText }}</div>
                  </div>
                </div>
              </div>
              <div class="loadOptionWrapper">
                <div class="centerAux">
                  <div class="loadOptionContainer" v-if="item.value !== ''" @click="deleteChoosenFile(key, item)">
                    <span class="loadOptionIcon">
                      <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18.99 5.38C18.98 5.35 18.97 5.31 18.96 5.28C18.96 5.27 18.95 5.27 18.95 5.26C18.93 5.23 18.91 5.2 18.89 5.17L13.9 0.11C13.88 0.09 13.85 0.06 13.82 0.05C13.81 0.05 13.81 0.04 13.8 0.04C13.77 0.03 13.74 0.01 13.7 0.01H13.69C13.66 0 13.64 0 13.61 0H2.01C0.9 0 0 0.91 0 2.03V21.96C0 23.09 0.9 24 2.01 24H16.99C18.1 24 19 23.09 19 21.97V5.46C19 5.43 19 5.41 18.99 5.38ZM14.01 1.97L17.1 5.08L15.23 5.06C14.56 5.06 14.01 4.51 14.01 3.82V1.97ZM17.88 21.97C17.88 22.37 17.32 22.91 16.99 22.91H2.01C1.68 22.91 1.12 22.36 1.12 21.97V2.03C1.12 1.63 1.4 1.17 2.01 1.17H12.85V3.81C12.85 5.25 13.61 5.99 15.22 5.99H17.88V21.97Z"
                          fill="#E4527F" />
                        <path
                          d="M13.41 15.6999L12.52 15.8799C12.38 15.9099 12.25 15.8199 12.23 15.6799C12.2 15.5399 12.29 15.3999 12.43 15.3799L14.15 15.0299L14.39 16.8899C14.41 17.0299 14.31 17.1599 14.18 17.1799C14.05 17.1999 13.92 17.0999 13.9 16.9599L13.78 16.0699L13.41 15.6999Z"
                          fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                        <path
                          d="M6.51 10.1199C6.65 10.0899 6.78 10.1799 6.8 10.3199C6.83 10.4599 6.74 10.5999 6.6 10.6199L4.88 10.9699L4.64 9.10986C4.62 8.96986 4.72 8.83986 4.86 8.81986C4.99 8.79986 5.12 8.89986 5.14 9.04986L5.26 9.93986L5.65 10.2899L6.51 10.1199Z"
                          fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.66004 11.6899C4.84004 11.7299 4.96004 11.8999 4.92004 12.0799C4.71004 13.1399 4.87004 14.2399 5.38004 15.1999C5.89004 16.1599 6.72004 16.8999 7.72004 17.3199C8.72004 17.7299 9.83004 17.7799 10.87 17.4699C11.91 17.1499 12.8 16.4799 13.4 15.5799C13.5 15.4299 13.71 15.3799 13.86 15.4899C14.01 15.5899 14.06 15.7999 13.95 15.9499C13.27 16.9799 12.25 17.7499 11.06 18.1099C9.88004 18.4699 8.60004 18.4099 7.46004 17.9399C6.32004 17.4699 5.37004 16.6099 4.79004 15.5199C4.21004 14.4299 4.02004 13.1699 4.26004 11.9499C4.30004 11.7699 4.48004 11.6499 4.66004 11.6899Z"
                          fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.33 8.69988C10.33 8.27988 9.22005 8.20988 8.18005 8.51988C7.14005 8.82988 6.24005 9.47988 5.63005 10.3799C5.53005 10.5299 5.32005 10.5699 5.17005 10.4699C5.02005 10.3699 4.98005 10.1599 5.08005 10.0099C5.77005 8.97988 6.80005 8.22988 7.99005 7.87988C9.18005 7.52988 10.45 7.59988 11.59 8.08988C12.73 8.56988 13.66 9.43988 14.24 10.5399C14.81 11.6399 14.98 12.8999 14.73 14.1099C14.69 14.2899 14.51 14.4099 14.33 14.3699C14.15 14.3299 14.03 14.1499 14.07 13.9699C14.29 12.9099 14.14 11.8099 13.64 10.8499C13.14 9.87988 12.32 9.11988 11.33 8.69988Z"
                          fill="#E4527F" stroke="#E4527F" stroke-width="0.5" stroke-miterlimit="10" />
                      </svg>
                    </span>
                    <span class="loadOptionText">{{
                      $t(
                        'message.FileUploadComponent.formComponent.replaceField'
                      )
                    }}</span>
                  </div>
                  <div class="loadOptionContainer" v-if="
                    key + 1 > metadata.json.min_files &&
                    key + 1 <= metadata.json.max_files
                  " @click="removeFilefromJson(key)">
                    <span class="loadOptionIcon">
                      <svg width="17" height="25" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.50911 20.5205C6.51216 20.5205 6.51497 20.5205 6.51802 20.5205C6.77672 20.5152 6.9827 20.2851 6.97802 20.006L6.74368 6.42162C6.73876 6.14277 6.52364 5.91393 6.26634 5.92605C6.00763 5.93136 5.80165 6.16146 5.80634 6.44056L6.04067 20.0249C6.0456 20.3005 6.25462 20.5205 6.50911 20.5205ZM9.93627 20.5205C10.191 20.5205 10.4 20.3005 10.4047 20.0247L10.639 6.44031C10.644 6.16146 10.438 5.9311 10.179 5.9258C10.176 5.9258 10.1732 5.9258 10.1701 5.9258C9.91542 5.9258 9.70639 6.1458 9.7017 6.42162L9.46737 20.006C9.46245 20.2848 9.66843 20.5152 9.92737 20.5205C9.93041 20.5205 9.93346 20.5205 9.93627 20.5205ZM14.54 5.92605C14.2717 5.92125 14.0648 6.13595 14.0566 6.4148L13.9898 8.64889C13.9816 8.92774 14.1845 9.16113 14.4433 9.16996C14.4484 9.16996 14.4536 9.17022 14.4585 9.17022C14.7104 9.17022 14.9185 8.95451 14.9267 8.68122L14.9935 6.44713C15.0017 6.16828 14.7985 5.93489 14.54 5.92605ZM14.4165 10.0565C14.4114 10.0565 14.4062 10.0563 14.4013 10.0563C14.1494 10.0563 13.9413 10.272 13.9331 10.5453L13.5875 22.1262C13.5875 22.6238 13.2123 23.0286 12.7516 23.0286H3.69474C3.23286 23.0286 2.85746 22.6238 2.85722 22.1098L2.38855 6.41429C2.38011 6.13544 2.16874 5.91974 1.90511 5.92555C1.64641 5.93464 1.44347 6.16777 1.45167 6.44662L1.92011 22.1257C1.92011 23.1805 2.71615 24.0385 3.69474 24.0385H12.7516C13.7295 24.0385 14.5248 23.1805 14.5246 22.1418L14.8697 10.5768C14.8779 10.2988 14.675 10.0654 14.4165 10.0565ZM15.7255 3.40023H11.9509L11.5595 1.36416C11.5145 1.12977 11.3228 0.961548 11.1007 0.961548H5.3454C5.12325 0.961548 4.93156 1.12977 4.88657 1.36416L4.49523 3.40023H0.718672C0.459965 3.40023 0.25 3.62654 0.25 3.90539C0.25 4.18425 0.459965 4.41056 0.718672 4.41056H4.87579C4.87579 4.41056 4.87602 4.41056 4.87626 4.41056H11.5675C11.568 4.41056 11.5684 4.41056 11.5689 4.41056C11.5691 4.41056 11.5696 4.41056 11.5701 4.41056H15.7255C15.9842 4.41056 16.1942 4.18425 16.1942 3.90539C16.1942 3.62654 15.9842 3.40023 15.7255 3.40023ZM5.45249 3.40023L5.72713 1.97188H10.7194L10.9941 3.40023H5.45249Z"
                          fill="#E4527F" />
                      </svg>
                    </span>
                    <span class="loadOptionText">{{
                      $t(
                        'message.FileUploadComponent.formComponent.eliminateField'
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </template>
      </template>
      <div class="flex justify-center">
        <div v-if="isFilesCompleted">
          <button v-if="documentsToUpload.length + 1 <= metadata.json.max_files" type="button"
            class="btn buttonPrimaryProperties" @click="appendNewFileToMetadata(index + 1)">
            {{ $t('message.settingsComponent.list.FileUploadComponent.addSheet') }}
          </button>
          <button type="button" class="btn buttonPrimaryProperties" @click="sendDocsToS3()">
            {{ $t('message.settingsComponent.list.FileUploadComponent.sendRRHH') }}
          </button>
        </div>
        <div v-else>
          <p class="text-zt-primary-200 text-center font-medium">
            {{ $t('message.settingsComponent.list.FileUploadComponent.enableSendRRHH') }}
          </p>
        </div>
      </div>
    </div>
    <div v-show="imgSrc">
      <dwt-capture-image v-if="!isNativeVersion" id="whateva" ref="DWTCaptureImage" :complete="doneCompleted" :resourcesPath="resourcePath"
        @change-editormode="editorMode" />
      <capture-image v-if="isNativeVersion && showNativeCapture" ref="DWTCaptureImage" :complete="doneCompleted"
        @change-editormode="editorMode"
        @register-event="onNativeCaptureReady"
        @change-image="step = 0"
        @save-image="handleNativeSaveImage"
        @load-error="handleNativeLoadError" />
      <footer v-show="step === 0" class="pie">
        <div class="employeeInfo footerIcons">
          <button class="buttonCamera" @click="cropImage">
            <em class="icon-Crop"></em>
            <span class="textButtonCamera">{{
              $t(
                'message.FileUploadComponent.cameraComponent.buttons.manualCrop'
              )
            }}</span>
          </button>
          <button class="buttonCamera" @click="rotateImage">
            <em class="icon-Rotate"></em>
            <span class="textButtonCamera">{{
              $t('message.FileUploadComponent.cameraComponent.buttons.rotate')
            }}</span>
          </button>
        </div>
        <div>
          <button class="deleteImage" @click="deleteImage">
            {{
              $t(
                'message.settingsComponent.list.FileUploadComponent.formComponent.eliminateFieldShort'
              )
            }}
          </button>
        </div>
        <div class="buttonsSaveImg">
          <button type="button" class="btn buttonSecondaryProperties" style="margin-left: 0;" @click="backToBeforePage">
            {{ $t('message.settingsComponent.header.cancelEditMode') }}
          </button>
          <button type="button" class="btn buttonPrimaryProperties" style="margin-left: 0;" @click="exitEditImage">
            {{ $t('message.settingsComponent.header.exitEditMode') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import ImageCompressor from 'image-compressor.js'
import UploadFiles from '../../apiClient/UploadFiles'
import sichernDwt from '@/components/generics/dwt/DWTCaptureImage.vue'
import CaptureImage from '@/components/generics/image-capture/CaptureImage.vue'
import isEmpty from 'lodash/isEmpty'
import customAlert from './utils/customSwal'
import CustomSwalFooter from './CustomSwalFooter.vue'
import findIndex from 'lodash/findIndex'

export default {
  components: {
    DwtCaptureImage: sichernDwt,
    CaptureImage
  },
  provide() {
    return {
      editorMode: this.editorMode
    }
  },
  props: ['metadata', 'imageText', 'pdfText'],
  data() {
    return {
      files: null,
      actualImageIndex: 0,
      minimunFilesRequired: 0,
      countDocumentsToUpload: 0,
      documentsToUpload: [],
      loadId: undefined,
      uploadValidators: {
        loadCheck: 0,
        problemOnUpload: false,
        renderSendButton: false
      },
      imgSrc: false,
      step: 0,
      loading: false,
      disabled: false,
      autoDetection: false,
      countAutoDetection: 0,
      resetCornerPos: null,
      index: 0,
      doneCompleted: false,
      dniLabels: ['Frente', 'Dorso'],
      resourcePath: process.env.VUE_APP_BASE + 'dwt-resources',
      showNativeCapture: false
    }
  },
  created() {
    this.uploadFiles = new UploadFiles()
    this.files = this.metadata.json.files
    this.createJsonToUpload()
  },
  updated() { },
  computed: {
    isNativeVersion() {
      return this.$store.getters.getIsNativeVersion
    },
    isAKindOfDni() {
      return this.metadata.json.max_files === this.metadata.json.min_files
    },
    isFilesCompleted() {
      return !this.documentsToUpload.some(document => isEmpty(document.value))
    },
    swalDniConfig() {
      if (!this.isAKindOfDni) {
        return false
      }

      if (this.isFilesCompleted) {

        const messageDni = this.$t('message.settingsComponent.list.FileUploadComponent.swal.dnimessage', { uploadLength: this.documentsToUpload.length })

        return {
          type: 'success',
          title: `<span class="text-zt-primary-200">${messageDni}</span>`,
          html: '<div id="VueSweetAlert2"><custom-component /></div>',
          showConfirmButton: false,
          onBeforeOpen: () => {
            customAlert(
              CustomSwalFooter,
              {
                sendDocs: this.sendDocsToS3,
                isDni: true,
                message:
                  this.$t('message.FileUploadComponent.sendFileRRHH'),
              },
              'VueSweetAlert2'
            )
          }
        }
      }

      const pending = findIndex(this.documentsToUpload, { value: '' });
      const messageDni = this.$t('message.settingsComponent.list.FileUploadComponent.swal.dniUploading', { uploadLength: this.documentsToUpload.length });
      const msgUpload = this.$t('message.settingsComponent.list.FileUploadComponent.swal.fileUploadingDNI', { dniLabelIndex: this.dniLabels[pending] })

      return {
        type: 'success',
        title: `<span class="text-zt-sm text-zt-primary-200">${messageDni}</span>`,
        html: `<span class="text-zt-primary-200">${msgUpload}</span>`,
        showConfirmButton: true,
        confirmButtonText: this.$t('message.settingsComponent.list.FileUploadComponent.swal.understoodMSG')
      }
    },
    swalMultipleConfig() {
      return {
        type: 'success',
        title: `<span class="text-zt-primary-200">${this.$t("message.settingsComponent.list.FileUploadComponent.swal.imageSaved")}</span>`,
        html: '<div id="VueSweetAlert2"><custom-component /></div>',
        showConfirmButton: false,
        onBeforeOpen: () => {
          customAlert(
            CustomSwalFooter,
            {
              sendDocs: this.sendDocsToS3,
              isDni: this.isAKindOfDni,
              newPage: () => this.appendNewFileToMetadata(this.index + 1),
              message: this.$t('message.settingsComponent.list.FileUploadComponent.continueConfig'),
            },
            'VueSweetAlert2'
          )
        }
      }
    }
  },
  watch: {},
  mounted() {
    this.documentsToUpload = []
    this.createJsonToUpload()
    if (this.isNativeVersion) return
    this.showFileChooseWindow(this.index, 'replace')
    this.$refs.DWTCaptureImage.$on('change-image', () => {
      this.step = 0
    })
    this.$refs.DWTCaptureImage.$on('save-image', async obj => {
      this.step = 0
      const blobData = this.isNativeVersion ? obj : obj.result
      await new ImageCompressor(blobData, {
        quality: 0.5,
        maxWidth: 595, // pixels for A4 size @ 72 PPI/DPI
        maxHeight: 842, // pixels for A4 size @ 72 PPI/DPI
        convertSize: 5000000,
        success: async result => {
          const testBlob = Object.assign(result, {
            UrlOnLoad: URL.createObjectURL(result)
          })
          const numberRandom = Math.floor(Math.random() * 10000)
          const extensionFile = testBlob.type.split('/')[1]
          const currentImage = this.actualImageIndex

          this.files[currentImage].value = numberRandom + '.' + extensionFile
          this.files[currentImage].mimeType = testBlob.type
          this.documentsToUpload[currentImage].value =
            numberRandom + '.' + extensionFile
          this.documentsToUpload[currentImage].mimeType = testBlob.type
          this.$set(this.documentsToUpload[currentImage], 'file', testBlob)

          if (
            this.validImage(this.files[currentImage]) &&
            testBlob.size <= 5000000
          ) {
            const configSwal = this.isAKindOfDni
              ? { ...this.swalDniConfig }
              : { ...this.swalMultipleConfig }

            this.$swal(configSwal).then(async () => {
              if (this.documentsToUpload[currentImage].mandatory === true) {
                this.minimunFilesRequired++
              }
              this.countDocumentsToUpload++
              await this.$refs.DWTCaptureImage.close()
              this.imgSrc = false
              this.$store.dispatch('go_Back_camera_Handler', true)
            })
          } else {
            this.$swal({
              type: 'error',
              title: this.$t(
                'message.settingsComponent.list.FileUploadComponent.formComponent.selectJpgPng'
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t(
                'message.FileUploadComponent.swal.accept'
              )
            })
          }
        }
      })
    })
    this.$refs.DWTCaptureImage.$on('load-error', () => {
      this.imgSrc = false
      this.$swal({
        type: 'error',
        title: this.$t('message.settingsComponent.list.FileUploadComponent.formComponent.invalidFormatFile'),
        timer: 2500,
        showConfirmButton: true,
        confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
      })
    })
  },
  methods: {
    fitPdfThumb(key) {
      this.$nextTick(() => {
        const ref = this.$refs[`ztPDFViewer_${key}`]
        const viewer = Array.isArray(ref) ? ref[0] : ref
        if (viewer && typeof viewer.zoom === 'function') {
          viewer.zoom(0.4)
        }
      })
    },
    closeAux() {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    createJsonToUpload() {
      let clonedObj = JSON.parse(JSON.stringify(this.files))
      for (let key in clonedObj) {
        if (clonedObj.hasOwnProperty(key)) {
          this.documentsToUpload.push(clonedObj[key])
        }
      }
    },
    async removeFilefromJson(index) {
      if (this.documentsToUpload[index].hasOwnProperty('file')) {
        this.countDocumentsToUpload--
        if (this.documentsToUpload[index].mandatory === true) {
          this.minimunFilesRequired--
        }
      }
      this.$delete(this.documentsToUpload, index)
      this.$delete(this.files, index)
    },
    deleteChoosenFile(index, item) {
      item.value = ''
      item.mimeType = ''
      this.documentsToUpload[index].value = ''
      this.documentsToUpload[index].mimeType = ''
      this.$delete(item, 'file')
      if (item.mandatory === true) {
        this.minimunFilesRequired--
      }
      this.countDocumentsToUpload--
    },
    appendNewFileToMetadata(index) {
      let nameSplit = this.files[0].alias.split(' ')[0]
      let numberRandom = Math.floor(Math.random() * 10000)
      let newFile = {
        alias: nameSplit + ' Agregado ',
        hash: '',
        mandatory: false,
        mimeType: '',
        name: nameSplit + '_Agregado_' + numberRandom,
        order: numberRandom,
        value: ''
      }
      this.documentsToUpload.push(newFile)
      this.files.push(newFile)
      this.actualImageIndex = index
    },
    async sendDocuments(idLoad, synchronousLength, fileName) {
      return new Promise(async (resolve, reject) => {
        await this.uploadFiles
          .sendDocsToS3(
            idLoad,
            this.documentsToUpload[synchronousLength].name,
            this.documentsToUpload[synchronousLength].file
          )
          .then(res => {
            var response = res.data.results.data[0]
            response ? resolve(response) : reject()
          })
          .catch(error => {
            this.imgSrc = false
            this.uploadValidators.problemOnUpload = true
            this.loading = false
            this.uploadValidators.loadCheck = 0
            this.documentsToUpload = []
            this.countDocumentsToUpload = 0
            this.createJsonToUpload()
            this.$swal({
              type: 'error',
              title:
                this.$t(`message.errorReference.${error.response.data.code}`) +
                ' ' +
                fileName,
              showConfirmButton: true,
              confirmButtonText: this.$t(
                'message.FileUploadComponent.swal.accept'
              )
            })
          })
      })
    },
    async sendDocsToS3() {
      this.loading = true
      let metaToUpload = this.metadata
      metaToUpload.json.files = this.documentsToUpload
      this.uploadFiles
        .sendDocsToTemplate(metaToUpload.id, metaToUpload.json)
        .then(async response => {
          let idLoad = response.data.results.data[0]
          let synchronousLength = this.documentsToUpload.length - 1
          for (let index = 0; index < this.documentsToUpload.length; index++) {
            await this.sendDocuments(
              idLoad,
              synchronousLength,
              this.documentsToUpload[index].file.name
            )
              .then(response => {
                synchronousLength--
                if (response === true) {
                  this.uploadValidators.loadCheck++
                }
                this.uploadValidators.problemOnUpload = false
                if (
                  this.uploadValidators.loadCheck ===
                  this.documentsToUpload.length &&
                  this.uploadValidators.problemOnUpload === false
                ) {
                  this.uploadFiles
                    .changeLoadStatus(idLoad)
                    .then(response => {
                      this.loading = false
                      if (response.data.results.data[0] === true) {
                        let msg =
                          this.documentsToUpload.length > 1
                            ? this.$t(
                              'message.FileUploadComponent.formComponent.uploadSuccess',
                              { totalDocs: this.documentsToUpload.length }
                            )
                            : this.$t(
                              'message.FileUploadComponent.formComponent.uploadSuccess'
                            )
                        this.$swal({
                          type: 'success',
                          title: msg,
                          showConfirmButton: false,
                          confirmButtonText: this.$t(
                            'message.FileUploadComponent.swal.accept'
                          )
                        })
                          .then(() => {
                            this.$emit(
                              'rollbackSelectedDoc',
                              (this.docTypeSelected = {})
                            )
                            this.$emit(
                              'nullDocMetadata',
                              (this.documentMetadata = null)
                            )
                            this.$emit('updateKey', 1)
                            this.$emit('checkLoadAprove', true)
                            this.$emit('updateContainerSplit')
                            this.closeAux()
                          })
                          .catch(error => {
                            this.imgSrc = false
                            this.$swal({
                              type: 'error',
                              title: this.$t(
                                `message.errorReference.${error.response.data.code}`
                              ),
                              showConfirmButton: true,
                              confirmButtonText: this.$t(
                                'message.FileUploadComponent.swal.accept'
                              )
                            })
                          })
                      }
                    })
                    .catch(error => {
                      this.imgSrc = false
                      this.uploadValidators.problemOnUpload = true
                      this.loading = false
                      this.uploadValidators.loadCheck = 0
                      this.$emit(
                        'rollbackSelectedDoc',
                        (this.docTypeSelected = {})
                      )
                      this.$emit(
                        'nullDocMetadata',
                        (this.documentMetadata = null)
                      )
                      this.$emit('updateKey', 1)
                      this.$swal({
                        type: 'error',
                        title: this.$t(
                          `message.errorReference.${error.response.data.code}`
                        ),
                        showConfirmButton: true,
                        confirmButtonText: this.$t(
                          'message.FileUploadComponent.swal.accept'
                        )
                      })
                    })
                }
              })
              .catch(error => {
                this.imgSrc = false
                this.uploadValidators.problemOnUpload = true
                this.loading = false
                this.$swal({
                  type: 'error',
                  title: this.$t(
                    `message.errorReference.${error.response.data.code}`
                  ),
                  showConfirmButton: true,
                  confirmButtonText: this.$t(
                    'message.FileUploadComponent.swal.accept'
                  )
                })
              })
          }
        })
        .catch(error => {
          this.imgSrc = false
          if (error.response.data[0].code === '04019') {
            this.$swal({
              type: 'error',
              title: this.$t(
                'message.FileUploadComponent.formComponent.loadAllPages'
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
            })
          } else {
            this.$swal({
              type: 'error',
              title: this.$t(
                `message.errorReference.${error.response.data[0].code}`
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
            })
          }
        })
    },
    editorMode(value) {
      this.imgSrc = value
    },
    choosePdfFile(index) {
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = 'application/pdf'
      input.onchange = e => {
        var file = e.target.files[0]
        if (file.type === 'application/pdf' && file.size <= 5000000) {
          let renderImage = { UrlOnLoad: URL.createObjectURL(file) }
          file = Object.assign(file, renderImage)
          this.files[index].value = file.name
          this.files[index].mimeType = file.type
          this.documentsToUpload[index].value = file.name
          this.documentsToUpload[index].mimeType = file.type
          this.$set(this.documentsToUpload[index], 'file', file)
          this.countDocumentsToUpload++
          if (this.documentsToUpload[index].mandatory === true) {
            this.minimunFilesRequired++
          }
        } else if (file.type === 'application/pdf' && file.size >= 500000) {
          this.$swal({
            type: 'error',
            title: this.$t(
              'message.FileUploadComponent.formComponent.checkSizeOnPdf'
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t(
              'message.FileUploadComponent.swal.accept'
            )
          })
        } else {
          this.$swal({
            type: 'error',
            title: this.$t(
              'message.FileUploadComponent.formComponent.selectPdf'
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t(
              'message.FileUploadComponent.swal.accept'
            )
          })
        }
      }
      input.click()
    },
    async showFileChooseWindow(index, action) {
      if (action === 'add') {
        this.appendNewFileToMetadata(index + 1)
      } else {
        this.actualImageIndex = index
      }
      if (this.isNativeVersion) {
        if (!this.showNativeCapture) {
          this.showNativeCapture = true
          return // onNativeCaptureReady will call openWindow() once component mounts
        }
        this.$refs.DWTCaptureImage.openWindow()
        return
      }
      this.$refs.DWTCaptureImage.openWindow()
    },
    onNativeCaptureReady() {
      this.$refs.DWTCaptureImage.openWindow()
    },
    async handleNativeSaveImage(obj) {
      this.step = 0
      await new ImageCompressor(obj, {
        quality: 0.5,
        maxWidth: 595, // pixels for A4 size @ 72 PPI/DPI
        maxHeight: 842, // pixels for A4 size @ 72 PPI/DPI
        convertSize: 5000000,
        success: async result => {
          const testBlob = Object.assign(result, {
            UrlOnLoad: URL.createObjectURL(result)
          })
          const numberRandom = Math.floor(Math.random() * 10000)
          const extensionFile = testBlob.type.split('/')[1]
          const currentImage = this.actualImageIndex

          this.files[currentImage].value = numberRandom + '.' + extensionFile
          this.files[currentImage].mimeType = testBlob.type
          this.documentsToUpload[currentImage].value =
            numberRandom + '.' + extensionFile
          this.documentsToUpload[currentImage].mimeType = testBlob.type
          this.$set(this.documentsToUpload[currentImage], 'file', testBlob)

          if (
            this.validImage(this.files[currentImage]) &&
            testBlob.size <= 5000000
          ) {
            const configSwal = this.isAKindOfDni
              ? { ...this.swalDniConfig }
              : { ...this.swalMultipleConfig }

            this.$swal(configSwal).then(async () => {
              if (this.documentsToUpload[currentImage].mandatory === true) {
                this.minimunFilesRequired++
              }
              this.countDocumentsToUpload++
              await this.$refs.DWTCaptureImage.close()
              this.imgSrc = false
              this.$store.dispatch('go_Back_camera_Handler', true)
            })
          } else {
            this.$swal({
              type: 'error',
              title: this.$t(
                'message.settingsComponent.list.FileUploadComponent.formComponent.selectJpgPng'
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t(
                'message.FileUploadComponent.swal.accept'
              )
            })
          }
        }
      })
    },
    handleNativeLoadError() {
      this.imgSrc = false
      this.$swal({
        type: 'error',
        title: this.$t('message.settingsComponent.list.FileUploadComponent.formComponent.invalidFormatFile'),
        timer: 2500,
        showConfirmButton: true,
        confirmButtonText: this.$t('message.FileUploadComponent.swal.accept')
      })
    },
    validImage(item) {
      return (
        item.mimeType === 'image/png' ||
        item.mimeType === 'image/jpeg' ||
        item.mimeType === 'image/jpg'
      )
    },
    backToBeforePage() {
      this.$refs.DWTCaptureImage.close()
      this.$store.dispatch('go_Back_camera_Handler', true)
      this.step = 0
      this.imgSrc = false
      this.autoDetection = false
    },
    async exitEditImage() {
      this.disabled = true
      await this.$refs.DWTCaptureImage.toSave()
    },
    cropImage() {
      this.countCrop = this.countCrop + 1
      this.$refs.DWTCaptureImage.activeCropTool()
    },
    rotateImage() {
      this.$refs.DWTCaptureImage.rotate()
    },
    deleteImage() {
      this.$refs.DWTCaptureImage.close()
      this.showFileChooseWindow()
    }
  }
}
</script>
<style lang="scss" scoped>
@import './public/assets/scss/_config.scss';

.pdf-thumb {
  width: 22rem;
  max-width: 100%;
  height: 32rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep .pdf-thumb .zt-pdf-viewer,
::v-deep .pdf-thumb [class*="zt-pdf-viewer"] {
  overflow: hidden !important;
}
::v-deep .pdf-thumb canvas {
  display: block;
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  /* zt-pdf-viewer reserva ~10px de SCROLLBAR_PADDING/2 internamente, lo compensamos */
  margin-left: -10px !important;
  margin-right: 0 !important;
}

.imageCotainerDashboard {
  flex-direction: row;
  justify-content: center;
  display: flex;
}

.imageContentDashboard {
  width: 90%;
  align-self: center;
}

.pickers-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.containerPicker-Title {
  align-items: center;
  align-content: center;
  justify-content: space-between;
  display: none;
}

.EliminateFieldContainer {
  display: flex;
  align-items: center;
  align-content: center;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #969696;
}

.icon-Close::before {
  font-size: 1.4em;
  color: $bluePrimary;
}

.picker-title {
  color: #2470a0;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: justify;
  margin-bottom: 1em;
  margin-top: 1em;
  margin-left: 1em;
}

.pdfShowContainer {
  display: flex;
  justify-content: center;
  align-content: center;
}

.containerRemoveUpload {
  background-color: #bcbcbc;
  // padding-top: 2em;
  width: 2.6em;
  height: 2.6em;
  z-index: 1;
  border-radius: 50%;
  background-image: url(../../../public/assets/media/tasks/Delete.svg);
  background-size: 70% 70%;
  background-position: center;
  float: left;
}

.removeUpload {
  z-index: 1;
  // padding-top: 10px;
  // margin: 0 auto;
  // background-size: contain;
  // width: 40%;
}

.removeUpload.icon-Delete::before {
  margin-left: 0.06em;
  position: absolute;
  top: 3px;
  font-size: 1.5em;
  color: black !important;
}

.filepicker-section {
  height: 14em;
  width: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
  align-content: center;
  /* Background */
  background: #f5f5f5;
  /* Linea form */
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 2px;
}

.left-picker {
  width: 50%;

  display: table-cell;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
}

.lineSeparator {
  border-right: 1px dashed #bcbcbc;
}

.right-picker {
  width: 50%;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
}

.imageUpload {
  background-image: url(../../../public/assets/media/tasks/icon-image.png);
  background-size: contain;
  height: 100px;
  width: 100px;
  max-width: 15vw;
}

.pdfUpload {
  background-image: url(../../../public/assets/media/tasks/icon-pdf.png);
  height: 100px;
  width: 100px;
  background-size: 60%;
  background-position: center;
}

.uploadTitles {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5em;
  line-height: 23px;
  color: #969696;
  text-align: center;
}

.containerButtonsSendDocs {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.btnSendDocProperties {
  margin: 0 !important;
  width: 190px;
  background-color: #2470a0;
  border-color: #2470a0;
  position: absolute;
  top: 50px;
  right: 80px;
  z-index: 1000000;
}

.btnSendDocProperties:hover {
  background-color: #4fade8;
  border-color: #4fade8;
}

.navigateContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  margin-top: 1em;
}

.navigateArrowsContainerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
}

.navigateArrowsContainerRight[disabled] {
  color: red;
}

.textNavigateArrows[disabled] {
  color: $grayFont !important;
}

.navigateArrowsContainerLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
}

// clases de fede

.image-picker {
  border-right: 1px dashed #bcbcbc;
  flex: 1;
  padding: 1rem;
}

.pdf-picker {
  flex: 1;
  padding: 1rem;
}

.picker {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin: 6em 1;
}

.image-container {
  margin: 0 auto;
  background-size: contain;
  width: 30%;
}

.image_img {
  background-image: url(../../../public/assets/media/tasks/icon-image.png);
  height: 7vh;
}

.pdf_img {
  background-image: url(../../../public/assets/media/tasks/icon-pdf.png);
  height: 7vh;
  margin-bottom: 1em;
  margin-top: 2em;
}

.footerIcons {
  margin-top: 0.5em;
  float: none !important;
  display: flex;
  justify-content: space-around;
}

.buttonCamera {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.textButtonCamera {
  margin-top: 0.3em;
  color: black;
  font-size: 0.5em;
}

.employeeInfo {
  margin: auto;
  margin-bottom: 1em;
  font-size: 2em;
}

.buttonsSaveImg {
  width: 100%;

  .btn-primary {
    font-family: Roboto, Arial, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 14px;
  }

  .edit {
    color: $bluePrimary !important;
    margin-right: 10px !important;
    width: 35%;
    background-color: $white !important;
    border-color: white !important;

    &:hover {
      color: $bluePrimary !important;
    }
  }

  .save {
    width: 40%;
    margin-right: 10px !important;
  }

  // position: absolute !important;
  // bottom: 0;
}

.activeAutoDetection {
  background-color: #d0d0d0;
  border-bottom: 2px solid $warning;
}

@media (max-height: 640px) {
  .buttonsSaveImg {
    height: 95px;
    width: 100%;

    .btn-primary {
      font-family: Roboto, Arial, sans-serif;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 14px;
    }

    .edit {
      color: $bluePrimary !important;
      margin-right: 10px !important;
      width: 35%;
      background-color: $white !important;
      border-color: white !important;

      &:hover {
        color: $bluePrimary !important;
      }
    }

    .save {
      width: 40%;
      margin-right: 10px !important;
    }

    // position: absolute !important;
    // bottom: 0;
  }
}

@media (min-width: 320px) and (max-width: 330px) {
  .buttonsSaveImg {
    height: 75px;
    width: 100%;

    .btn-primary {
      font-family: Roboto, Arial, sans-serif;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 14px;
    }

    .edit {
      color: $bluePrimary !important;
      margin-right: 10px !important;
      width: 35%;
      background-color: $white !important;
      border-color: white !important;

      &:hover {
        color: $bluePrimary !important;
      }
    }

    .save {
      width: 40%;
      margin-right: 10px !important;
    }

    // position: absolute !important;
    // bottom: 0;
  }
}

.mbc {
  height: 100%;
  width: 100%;
  background: rgb(250, 250, 250) !important;
  /* background: #E9E9E9 !important; */
  padding: 3.6rem 0rem 0rem 0rem !important;
}

.pie {
  min-height: 65px;
  // background: #f4f5f8;
  color: $white;
  text-align: center;
  //position: fixed;
  // bottom: 30%;
  left: 0;
  width: 100%;
  padding: 0px;
  margin-left: 0px !important;
}

.loadNewImage {
  color: $textSecondary;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: justify;
  float: left;
}

.loadNewImage .icon-Plus {
  overflow: hidden;
  font-size: 1em;
}

.loadOptionWrapper {
  height: 48px;
  display: flex;
  background-color: white;
  padding-top: 12px;
  -webkit-box-shadow: 0px 3px 7px -1px rgba(0, 0, 0, 0.56);
  -moz-box-shadow: 0px 3px 7px -1px rgba(0, 0, 0, 0.56);
  box-shadow: 0px 3px 7px -1px rgba(0, 0, 0, 0.56);
}

.loadOptionContainer {
  height: 30px;
  width: auto;
  display: block;
  float: left;
}

.loadOptionContainer:hover {
  cursor: pointer;
}

.loadOptionText {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #969696;
}

.loadOptionIcon {
  float: left;
  margin: 0 12px;
}

.loadNewImage .icon-Plus::before {
  color: $textSecondary;
  font-size: 1.3em;
}

.centerAux {
  display: block;
  width: auto;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.titleContainer {
  position: fixed;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  height: 110px;
  background-color: white;
  z-index: 100000;
}

.titleContainerSplited {
  position: fixed;
  text-align: left;
  width: 50%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  height: 110px;
  background-color: white;
  z-index: 100000;
}

.titleContainerSplited .container,
.titleContainer .container {
  padding-top: 50px;
  padding-bottom: 18px;
}

.containersWrapperDocuments {
  margin-bottom: 36px;
  clear: both;
}
</style>
